import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ToastProvider } from './context/ToastContext.jsx';
import { StoreProvider, useStore } from './context/StoreContext.jsx';
import Header from './components/Header.jsx';
import Footer from './components/Footer.jsx';
import Drawers from './components/Drawers.jsx';
import ComingSoon from './components/ComingSoon.jsx';
import Home from './pages/Home.jsx';
import Shop from './pages/Shop.jsx';
import Product from './pages/Product.jsx';
import Checkout from './pages/Checkout.jsx';
import ThankYou from './pages/ThankYou.jsx';
import KoreanWear from './pages/KoreanWear.jsx';
import NotFound from './pages/NotFound.jsx';
import { About, Contact, Privacy, Terms } from './pages/Info.jsx';
import AdminApp from './pages/admin/AdminApp.jsx';

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Storefront() {
  const { status, reload } = useStore();
  if (status === 'loading') return <div className="boot" aria-busy="true" aria-label="Loading" />;
  // No backend running: the whole site shows Coming Soon
  if (status === 'down') return <ComingSoon onRetry={reload} />;
  return (
    <>
      <Header />
      <ScrollToTop />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:main" element={<Shop />} />
          <Route path="/shop/:main/:sub" element={<Shop />} />
          <Route path="/product/:id" element={<Product />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/korean-wear" element={<KoreanWear />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms-conditions" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <Drawers />
    </>
  );
}

export default function App() {
  return (
    <ToastProvider>
      <BrowserRouter>
        <Routes>
          {/* The admin panel manages its own connection state */}
          <Route path="/admin/*" element={<AdminApp />} />
          <Route
            path="*"
            element={
              <StoreProvider>
                <Storefront />
              </StoreProvider>
            }
          />
        </Routes>
      </BrowserRouter>
    </ToastProvider>
  );
}
